<div>
    <span></span>
    <h2>{{ title }}</h2>
</div>